export const SLIDES_PER_VIEW_DEFAULT_VALUE = 1;
export const LAST_SLIDE_THRESHOLD = 0.95;
export const WAIT_TIME = 100;
export const SLIDER_CLASSNAME = 'keen-slider';
export const SLIDE_CLASSNAME = `${SLIDER_CLASSNAME}__slide`;
export const MAX_VISIBLE_PAGINATION_ITEMS = 8;
//# sourceMappingURL=constants.js.map